import Vue from 'vue'
import {AclInstaller, AclCreate, AclRule} from 'vue-acl'
import router from "../router";
import store from "../store";


Vue.use(AclInstaller)

export default new AclCreate({
  initial: 'none',
  notfound: {
    path: '/error',
    forwardQueryParams: true,
  },
  router,
  acceptLocalRules: true,
  globalRules: {
    isAdmin: new AclRule('admin').generate(),
    isPublic: new AclRule('public').or('none').or('admin').or('treasury').generate(),
    isBackoffice: new AclRule('admin').or('treasury').generate()
  },
  middleware: async acl => {
    let user = store.getters["auth/getUser"];
    if (user && user.user_roles) {
      acl.change("admin")
    } else {
      acl.change("public");
    }
  }
})
